module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-backoffice-attachment"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.url
    }
  }), _c('a', {
    staticClass: "button button-download expanded",
    on: {
      "click": function($event) {
        return _vm.openUrl(_vm.item.url)
      }
    }
  }, [_vm._v("Download")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f2919da!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Attachment.vue
// module id = 2438
// module chunks = 1